<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item' @child-event='getNumVal'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' :data-val='item'></Choose>
		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import stringUtils from "../assets/js/stringUtil.js";
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'
	import {
		getTemplateInfo,
		submitProcess,
		getMediaId
	} from '@/api/approval'
	import {
		getRelation
	} from '@/api/employee'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};

	import {
		formatDate
	} from '@/utils/date'
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				listLoading: false,
				isDisabled: false,
				selectHourse: [],
				flowId: null
			}
		},
		created() {
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			stringUtils.setAddIsShow(true);
			this.flowId = this.$route.query.flowId;
			this.getTemplate();
		},
		methods: { //方法
			getTemplate: async function() {
				var departName = this.logInfo.fullName;
				var departs = this.logInfo.fullName.split("/");
				var jobLevel = this.logInfo.JobLevel;
				var that = this;
				await this.getEmployeeRelation();
				if (
				    departs.indexOf("联动项目部") == -1 &&
				    departs.indexOf("事业部") == -1 &&
					departs.indexOf("企业顾问中心") == -1 &&
					departs.indexOf("商业地产部") == -1 &&
					departs.indexOf("代理") == -1 &&
					departs.indexOf("二级市场营运中心") == -1 &&
					departs.indexOf("住宅部") == -1 &&
					departs.indexOf("按揭金融服务中心") == -1 &&
					this.isDisabled == false
				) {
					this.Message({
						message: '没有申请权限',
						type: 'error',
						duration: 1000
					});
					this.isDisabled = true;
				}
				this.listLoading = true;
				getTemplateInfo(this.templateId).then(async response => {

					var controls = response.Body;

					controls.TemplateContent.Controls.forEach(async (item) => {
						if (item.Property.Title[0].Text == "委托日期") {
							item.Disabled = false;
							let date = new Date();
							item.Value = formatDate(date, "yyyy-MM-dd");
						}

						if (item.Property.Title[0].Text == "承担比例" || item.Property.Title[0].Text == "住宅部大战区") {
							if (departName.indexOf("房友圈") > -1 || departName.indexOf("藤云") || departName.indexOf("商业地产部") > -1) {
								item.IsShow = true;
								if (item.Property.Title[0].Text == "承担比例") {
									if (departName.indexOf("房友圈") > -1) {
										item.Property.Title[0].Text = "房友圈承担预交诉讼费比例";
									} else {
										item.Property.Title[0].Text = "商业地产部承担预交诉讼费比例";
									}

								}
								if (departName.indexOf("房友圈") > -1 || departName.indexOf("藤云")) {
									item.Property.Require = 1
								}
							} else {
								item.IsShow = false;
							}
						}
						if(item.Property.Title[0].Text == "是否选择房友圈"){
							if(departName.indexOf("商业地产部") > -1){
								item.IsShow = true;
							}else{
								item.IsShow = false;
							}
						}
						if (item.Property.Title[0].Text == "住宅部大战区总") {
							item.Values = [];
							item.Values.push(["SC24000029", "钟志斌"]);
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "所在部门") {
							if (departs.indexOf("房友圈") > -1 || departs.indexOf("藤云") > -1) {
								if (departs.indexOf("联动项目部") > -1||departs.indexOf("企业顾问中心") > -1||departs.indexOf("事业部") > -1) {
									item.Value = item.Config.Selector.Options.filter(o => {
										return o.Value[0].Text == "房友圈"
									})[0].Key;
								}
							} else if (departs.indexOf("住宅行政支持组") > -1) {
								item.Value = item.Config.Selector.Options.filter(o => {
									return o.Value[0].Text == "住宅行政支持组"
								})[0].Key;
							} else if (departs.indexOf("住宅部") > -1) {
								item.Value = item.Config.Selector.Options.filter(o => {
									return o.Value[0].Text == "住宅部"
								})[0].Key;
							} else if (departs.indexOf("按揭金融服务中心") > -1) {
								item.Value = item.Config.Selector.Options.filter(o => {
									return o.Value[0].Text == "汇瀚"
								})[0].Key;
							} else if (departs.indexOf("二级市场营运中心") > -1 || departs.indexOf("代理") > -1) {
								item.Value = item.Config.Selector.Options.filter(o => {
									return o.Value[0].Text == "二级市场营运中心/代理"
								})[0].Key;
							} else if (departs.indexOf("商业地产部") > -1) {
								item.Value = item.Config.Selector.Options.filter(o => {
									return o.Value[0].Text == "工商铺商业运营中心"
								})[0].Key;
							}
							item.Disable = true;
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "住宅部承担预交诉讼费比例") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "委托部门") {
							item.Value = "风险管理部"
						}
						if (item.Property.Title[0].Text == "流程编号") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "过户与还款协议情况") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "发票编号") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "流程条件") {
							if (departs.indexOf("商业地产部") > -1) {
								if (jobLevel >= 6) {
									item.Value = 1
								} else {
									var isMatch = that.getSuperiorIsMatchDepth(that.relationList, 6, 1);
									if (isMatch) {
										item.Value = 1;
									} else {
										item.Value = that.getCondtion(that.relationList, 6, 1);
									}
								}
							}
							if (departs.indexOf("房友圈") > -1 || departs.indexOf("藤云") > -1) {
								if (jobLevel >= 7) {
									item.Value = 2
								} else {
									var isMatch = that.getSuperiorIsMatchDepth(that.relationList, 7, 1);
									if (isMatch) {
										item.Value = 2;
									} else {
										item.Value = that.getCondtion(that.relationList, 7, 2);
									}
								}
							}
							if (departs.indexOf("二级市场营运中心") > -1 || departs.indexOf("代理") > -1) {
								if (departName.indexOf("非营业") > -1) {
									item.Value = 1;
								} else if (jobLevel >= 7) {
									item.Value = 3
								} else {
									var isMatch = that.getSuperiorIsMatchDepth(that.relationList, 7, 1);
									if (isMatch) {
										item.Value = 3.1;
									} else {
										item.Value = that.getCondtion(that.relationList, 8, 3);
									}
								}
							}
							if (departs.indexOf("住宅部") > -1) {
								if (departName.indexOf("东南区")) {
									if (jobLevel >= 8) {
										item.Value = 4;
									} else {
										var isMatch = that.getSuperiorIsMatchDepth(that.relationList, 8, 1);
										if (isMatch) {
											item.Value = 4;
										} else {
											item.Value = that.getCondtion(that.relationList, 8, 4);
										}
									}
								} else if (departName.indexOf("西南区")) {
									if (jobLevel >= 6) {
										item.Value = 4;
									} else {
										var isMatch = that.getSuperiorIsMatchDepth(that.relationList, 6, 1);
										if (isMatch) {
											item.Value = 4;
										} else {
											item.Value = that.getCondtion(that.relationList, 6, 4);
										}
									}
								} else {
									if (jobLevel >= 7) {
										item.Value = 4;
									} else {
										var isMatch = that.getSuperiorIsMatchDepth(that.relationList, 7, 1);
										if (isMatch) {
											item.Value = 4;
										} else {
											item.Value = that.getCondtion(that.relationList, 7, 4);
										}
									}
								}

							}
							if (departs.indexOf("按揭金融服务中心") > -1) {
								if (jobLevel >= 5) {
									item.Value = 5
								} else {
									var isMatch = that.getSuperiorIsMatchDepth(that.relationList, 5, 1);
									if (isMatch) {
										item.Value = 5;
									} else {
										item.Value = that.getCondtion(that.relationList, 5, 5);
									}
								}
							}
						}
					});
					that.templateData = that.assignControl(controls, that.logInfo);
					that.templateData = await that.assignControlBySpNo(controls, null, that.flowId);
					that.listLoading = false;
					await controls.TemplateContent.Controls.forEach(async (item) => {
						if (item.Property.Title[0].Text == "附件") {
							that.$set(item, 'fileNames', [])
							if (item.Values != null) {
								item.Values.forEach(async data => {
									await getMediaId(data[0]).then(res => {
										data[0] = res.MediaId;
										item.fileNames.push({
											"key": res.fileName,
											"val": res.MediaId
										});
									});
								});
							}
						}
					})
				});
			},
			getEmployeeRelation: async function() {
				await getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal(val, name) {
				if (name == '甲方名称') {
					var control1 = this.templateData.TemplateContent.Controls.filter(t => {
						return t.Property.Title[0].Text.indexOf("甲方名称") > -1
					})[0];
					if (val.length > 30) {
						control1.Value = "";
						this.Message({
							message: '字数不能大于30字',
							type: 'error',
							duration: 1000
						});
					}
				}
			},
			getNumVal(val, name) {
				if (name.indexOf("比例") > -1) {
					var value = parseInt(val);
					var control1 = this.templateData.TemplateContent.Controls.filter(t => {
						return t.Property.Title[0].Text.indexOf("比例") > -1
					})[0];
					var control2 = this.templateData.TemplateContent.Controls.filter(t => {
						return t.Property.Title[0].Text == "住宅部承担预交诉讼费比例"
					})[0];
					if (name.indexOf("住宅部承担预交诉讼费比例") > -1) {
						if (val != null && val.length > 0) {
							if (value >= 100) {
								control2.Value = 0;
							} else if (value <= 0) {
								control1.Value = 100;
							} else {
								control1.Value = (100 - value).toString();
							}
						}

					} else {
						if (val != null && val.length > 0) {
							if (value >= 100 || value == 0) {
								control1.Value = 0;
							} else if (value <= 0) {
								control2.Value = 100;
							} else {
								control2.Value = (100 - value).toString();
							}
						}

					}
				}else if (name == "追收金额(小写)") {
					var controls = this.templateData.TemplateContent.Controls;
					var controlInfo = controls.filter(item => item.Property.Title[0].Text == "追收金额(大写)")[0];
					var ret = "";
					if (val != "" && val != null && val != "0") {
						var unit = "仟佰拾亿仟佰拾万仟佰拾元角分",
							str = "";
						val += "00";
						var point = val.indexOf(".");
						if (point >= 0) {
							val = val.substring(0, point) + val.substr(point + 1, 2);
						}
						unit = unit.substr(unit.length - val.length);
						for (var i = 0; i < val.length; i++) {
							str +=
								"零壹贰叁肆伍陆柒捌玖".charAt(val.charAt(i)) + unit.charAt(i);
						}
						ret =
							str
							.replace(/零(仟|佰|拾|角)/g, "零")
							.replace(/(零)+/g, "零")
							.replace(/零(万|亿|元)/g, "$1")
							.replace(/(亿)万|(拾)/g, "$1$2")
							.replace(/^元零?|零分/g, "")
							.replace(/元$/g, "元") + "整";
					}
					controlInfo.Value = ret;
				}
			},
			getSelectorVal(val, name) {
				var controls = this.templateData.TemplateContent.Controls;
				var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
				if (name == "是否存在已开发票未回款情况") {
					var option = controlInfo.Config.Selector.Options
						.filter(item => {
							return item.Value[0].Text == "是" && item.Key == val;
						})[0];
					var control = controls.filter(item => item.Property.Title[0].Text == "发票编号")[0];
					if (option != null) {
						control.IsShow = true;
						control.Property.Require = 1;
					} else {
						control.IsShow = false;
						control.Property.Require = 0;
					}
				}
				if (name == "住宅部大战区") {
					var isSouth = false;
					var control = controls.filter(item => item.Property.Title[0].Text == "住宅部承担预交诉讼费比例")[0];
					var controlHourse = controls.filter(item => item.Property.Title[0].Text == "住宅部大战区总")[0];
					var options = controlInfo.Config.Selector.Options
						.filter(item => {
							return val.indexOf(item.Key) > -1;
						});
					controlHourse.Values = [];
					options.forEach(item => {
						if (item.Value[0].Text == "南区") {
							controlHourse.Values.push(["HB17003554", "张家华"]);
						}
						if (item.Value[0].Text == "北区") {
							controlHourse.Values.push(["HB12030069", "潘强龙"]);
							
						}
					});
					if (val.length > 0) {
						control.IsShow = true;
						control.Property.Require = 1;
					} else {
						control.IsShow = false;
						control.Property.Require = 0;
					}
				}
				if (name == "追佣类型") {
					var option = controlInfo.Config.Selector.Options
						.filter(item => {
							return item.Value[0].Text == "二手" && item.Key == val;
						})[0];
					var control = controls.filter(item => item.Property.Title[0].Text == "过户与还款协议情况")[0];
					if (option != null) {
						control.IsShow = true;
						control.Property.Require = 1;
					} else {
						control.IsShow = false;
						control.Property.Require = 0;
					}
				}
				this.$forceUpdate()
			},
			tableOperation(val, type, datas) {
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				var SummaryList = [];
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				var control1 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "部门"
				})[0]
				info.SummaryInfo.push({
					"Text": "申请部门：" + control1.Value,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);

				var control2 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "项目名称"
				})[0]
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				info.SummaryInfo.push({
					"Text": "项目名称：" + control2.Value,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);

				var control3 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "追佣类型"
				})[0]
				var control3Text = control3.Config.Selector.Options.filter(t => {
					return t.Key == control3.Value
				})[0].Value[0].Text;
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				info.SummaryInfo.push({
					"Text": "追佣类型：" + control3Text,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);


				this.templateData.SummaryList = SummaryList
				isSubmit = true;
				this.listLoading = true;
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
				});
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
